// extracted by mini-css-extract-plugin
export var active = "_9g-a";
export var activeIndicator = "_9g-9";
export var disabled = "_9g-b";
export var fullWidth = "_9g-2";
export var lg = "_9g-7";
export var md = "_9g-6";
export var redoButtonTabGroup = "_9g-0";
export var sm = "_9g-5";
export var tabButton = "_9g-4";
export var tabButtonsContainer = "_9g-1";
export var themeDestructive = "_9g-d";
export var themeNormal = "_9g-c";
export var themeSuccess = "_9g-e";
export var xl = "_9g-8";
export var xs = "_9g-3";